export enum GroupType {
    NoList = 'no-list',
    Only = 'only'
}
